import React, { useState } from "react";
import "./RegmalSecond.scss";
import { PageMode } from "utils/constant";
import { useEffect } from "react";
import TableComponent from "./components/TableComponent";
import FormComponent from "./components/FormComponent";
import { useSelector } from "react-redux";

const RegmalSecond = () => {
  const [pageMode, setPageMode] = useState(PageMode.view);

  const { currentUser } = useSelector((state) => state.authReducer);

  console.log(currentUser.level);

  useEffect(() => {
    if (currentUser.level === "BKKWilker" || currentUser.level === "BKKInduk") {
      document.title = "SISMAL | Register Malaria 2 BKK";
    } else {
      document.title = "SISMAL | Register Malaria 2";
    }
  }, []);

  const changePageMode = (mode) => {
    setPageMode(mode);
  };

  return (
    <div className="dashboard-wrapper">
      {pageMode === PageMode.view && (
        <TableComponent changeMode={changePageMode} />
      )}
      {(pageMode === PageMode.add || pageMode === PageMode.edit) && (
        <FormComponent changeMode={changePageMode} pageMode={pageMode} />
      )}
    </div>
  );
};

export default RegmalSecond;
